"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var SelectOneBlockContainer =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(SelectOneBlockContainer, _BlockContainer);

  function SelectOneBlockContainer() {
    babelHelpers.classCallCheck(this, SelectOneBlockContainer);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(SelectOneBlockContainer).apply(this, arguments));
  }

  return SelectOneBlockContainer;
}(_base.BlockContainer);

exports.default = SelectOneBlockContainer;